/* The integrations strip and the integrations grid. v2.

   TWO RENDERERS, ONE LIST. Both read window.RK_INTEGRATIONS from
   rockkt-integrations-data-v2.js, which is the only place the tools are named.

     buildStrip()  homepage only. A compact band of logos, inserted low on the
                   page, immediately before the closing call to action and after
                   the nine-button band if that is there. It is deliberately
                   SHORT - one heading line and a wrapping row of tiles - because
                   the homepage is already long and this is a reassurance, not a
                   feature section.

     buildGrid()   /pages/integrations only. The same tools at a size you can
                   actually look at.

   ── WHAT CHANGED FROM v1 ────────────────────────────────────────
   v1 shipped with window.RK_INT_LOGOS empty, so every tile fell back to the
   vendor's name set in type. All twelve marks now exist as theme assets and the
   map is filled in snippets/rockkt-int-logos-v1.liquid, so the wordmark path
   below is now a fallback rather than the shipped state. It is deliberately
   KEPT: a thirteenth tool added to the data file before anyone has its logo
   still renders, and the row still reads, rather than showing a broken image.

   The sizing changed with it. v1 asked "is this mark under 2:1" and applied one
   fixed boost. Twelve real marks turn out to have five different constructions -
   see the note in the data file - so the boost is now a NUMBER the data file
   carries per logo (`h`), passed to CSS as a custom property. This file no
   longer decides anything about size; it only forwards what the data file says.

   That is the third time this particular sizing has been got wrong, and each
   attempt failed in the same way: a rule written in one place about values that
   live in another. v1's first draft tested the ratio with a CSS attribute
   substring match, so `[style*="--r:1"]` caught `--r:1.42` and silently doubled
   Salesforce. v1's second draft moved the test into JS but hard-coded the
   threshold and the boost here, away from the numbers they judge. Now the file
   that knows the mark states its own height, and nothing else has an opinion.

   ── TWO COPY EDITS, 1 OCT ───────────────────────────────────────
   The strip's standfirst ended "No middleware, no integration fee." and the
   link below it read "How the integrations work →". Both are on every list of
   the things that mark a page as generated rather than written: the repeated
   "no X, no Y" beat, and an arrow glyph welded to a link that already looks
   like a link. Neither earned its place, so both are gone. Deliberately NOT
   version-bumped - nothing about what this file renders changed, and the
   layout would have had to be rewritten whole to point at a new name.

   If a link here ever needs an arrow back, it should be an <svg> that the
   stylesheet can animate, not a character inside the label. */
(function () {
  var LIST = window.RK_INTEGRATIONS || [];
  var CUSTOM = window.RK_INTEGRATIONS_CUSTOM || 'Custom on request';
  /* id -> asset URL, built by snippets/rockkt-int-logos-v1.liquid from the logo
     files that exist. An id missing from it draws the vendor's name instead,
     and an empty map is still a valid state: the whole row falls back together. */
  var LOGOS = window.RK_INT_LOGOS || {};
  if (!LIST.length) return;

  function tile(it, cls) {
    var url = LOGOS[it.id];
    /* --r and --h are the file's own numbers, straight from the data file.
       CSS multiplies the base height by --h and derives the width from --r; the
       cap that stops a very wide mark touching the tile edge lives in the
       stylesheet, where the tile's width is also set. */
    var inner = url
      ? '<span class="rk-int-mark" style="--r:' + (it.ratio || 4.2) + ';--h:' + (it.h || 1) + '">' +
          '<img src="' + url + '" alt="" loading="lazy" decoding="async">' +
        '</span>'
      : '<span class="rk-int-word">' + it.name + '</span>';
    /* The name is on every tile for a screen reader even when the logo carries
       it visually - a logo is an image of a word, not the word. */
    return '<span class="' + cls + '" title="' + it.name + '">' + inner +
           '<span class="rk-int-sr">' + it.name + '</span></span>';
  }

  /* ---- homepage strip ---------------------------------------------------- */

  /* Same anchor the button band uses, and for the same reason: the closing ask
     should be the last thing on the page. Each fallback is one step further
     out and the last cannot fail. */
  function anchorNode() {
    return document.getElementById('cta')
        || document.querySelector('section.final')
        || document.querySelector('.rk-ask')
        || document.querySelector('footer');
  }

  function buildStrip() {
    if (document.querySelector('.rk-int-strip')) return;      /* already built */
    var anchor = anchorNode();
    if (!anchor || !anchor.parentNode) return;

    var sec = document.createElement('section');
    sec.className = 'rk-int-strip';
    sec.setAttribute('aria-labelledby', 'rkIntTitle');
    /* .wrap is the page's own 1140px container, NOT one of this file's. The
       button band directly above uses it, and inheriting it is what makes the
       two panels line up edge to edge. An override here was 1180px and put this
       panel 40px wider than the band. */
    sec.innerHTML =
      '<div class="wrap"><div class="rk-int-panel">' +
        '<div class="rk-int-head">' +
          '<span class="rk-int-eyebrow">Integrations</span>' +
          '<h2 id="rkIntTitle">It already talks to your CRM.</h2>' +
          '<p>' + LIST.length + ' prebuilt connections, included on every plan and switched on from your settings.</p>' +
        '</div>' +
        '<div class="rk-int-row">' +
          LIST.map(function (it) { return tile(it, 'rk-int-tile'); }).join('') +
          '<span class="rk-int-tile rk-int-custom">' + CUSTOM + '</span>' +
        '</div>' +
        '<a class="rk-int-more" href="/pages/integrations">How the integrations work</a>' +
      '</div></div>';

    /* After the button band when there is one, so the page reads: sections,
       "Nine places to look next", integrations, the ask. */
    var band = document.querySelector('.rkx6');
    if (band && band.parentNode === anchor.parentNode) {
      band.parentNode.insertBefore(sec, band.nextSibling);
    } else {
      anchor.parentNode.insertBefore(sec, anchor);
    }
  }

  /* ---- the page ---------------------------------------------------------- */

  function buildGrid() {
    var host = document.getElementById('rkIntGrid');
    if (!host || host.getAttribute('data-built')) return;
    host.setAttribute('data-built', '1');
    host.innerHTML =
      LIST.map(function (it) { return tile(it, 'rk-int-card'); }).join('') +
      '<span class="rk-int-card rk-int-custom">' + CUSTOM + '</span>';
    /* The count, wherever the page asked for it. Nothing here hard-codes it,
       so adding a tool cannot leave a stale number behind - which is the
       mistake the button band's heading made twice. */
    var n = document.querySelectorAll('[data-rk-int-count]');
    for (var i = 0; i < n.length; i++) n[i].textContent = String(LIST.length);
  }

  function build() {
    if (document.getElementById('rkIntGrid')) buildGrid();
    else if (document.body.classList.contains('rk-home') || document.querySelector('.rkx6') || isHome()) buildStrip();
  }

  /* The homepage is the only template with the button band OR the ask box, and
     on this theme it is also the only one served at "/". Any one of the three
     is enough; all three missing means this is some other page and the strip
     stays off it. */
  function isHome() {
    var p = location.pathname.replace(/\/+$/, '');
    return p === '' || p === '/index';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  /* The button band is injected by rockkt-router-v7.js, which is deferred like
     this file. Run again after load so the strip lands after the band whichever
     of the two wins the race. */
  window.addEventListener('load', function () { setTimeout(build, 120); });
})();
